<template>
   <div id="pgHome" class="layout-page">
      <h1>Dashboard</h1>

      <p>Welcome to {{ appName }}. Choose from one of the options below...</p>

      <div class="alert alert-danger alert-dismissible fade show font-smaller" role="alert" v-if="warningDays != 0">
         <i class="fas fa-exclamation-triangle"></i>&nbsp;
         <strong>Important:</strong> You have <strong>{{ warningDays }}</strong> more days to <a href="#"
                                                                                                 @click.prevent="buttonAppoint()">complete your application</a>.
         After then you will need to start over.
         <button type="button" class="close" data-dismiss="alert" aria-label="Close">
            <span aria-hidden="true">&times;</span>
         </button>
      </div>

      <div class="container-fluid">
         <div class="row mart-24">

            <div class="col-xs-0 col-sm-1"></div>
            <div class="col-sm-4">
               <div class="dash-box b-card" v-cloak>
                  <div class="card-body">
                     <div class="text-center" v-if="loading">
                        <i class="fas fa-spinner fa-spin ml-orange fa-lg"></i>
                     </div>
                     <div v-else>
                        <div v-if="displayAppointments.length > 0">
                           <div class="text-center padb-12" v-for="(a, indx) in displayAppointments" :key="indx">
                              <button type="button" @click.prevent="buttonAppoint(a)"
                                      class="btn btn-lg ml-btn ml-bk-corp ml-white wf-btn">
                                 <span v-if="a.status == 'NEW'"
                                       v-tooltip:bottom="'Start filling out a new appointment application' + forApplicationLevel(a)">
                                    <i class="fas fa-user-plus"></i>
                                    Complete Your Appointment
                                 </span>
                                 <span v-if="a.status != 'APWF_STATUS_APPROVED' && a.status != 'NEW' && a.status != 'APWF_STATUS_NEWCONTRACT'"
                                       v-tooltip:bottom="'Resume filling your appointment application' + forApplicationLevel(a)">
                                    <i class="fas fa-user-edit"></i>
                                    Resume Your Appointment
                                 </span>
                                 <span v-if="a.status == 'APWF_STATUS_NEWCONTRACT'"
                                       v-tooltip:right="'View your application that is awaiting approval.'">
                                    <i class="fas fa-user-clock"></i>
                                    View Your Pending Appointment
                                 </span>
                                 <span v-if="a.status == 'APWF_STATUS_APPROVED' && isVBAppointment"
                                       v-tooltip:right="'View your application that was approved.'">
                                    <i class="fas fa-user-clock"></i>
                                    View Your Approved Appointment
                                 </span>
                              </button>
                           </div>
                        </div>
                        <div v-if="!isVBAppointment" class="text-center padb-12">
                           <button type="button" @click.prevent="buttonClick('AGENTS')"
                                   class="btn btn-lg ml-btn ml-bk-corp ml-white"
                                   v-tooltip:right="'View any downline you may have recruited'" :disabled="hasNoAppointments">
                              <i class="fi-interface-organization"></i>
                              View Agent Hierarchy
                           </button>
                        </div>
                        <div v-if="!isVBAppointment" class="text-center padb-12">
                           <button type="button" @click.prevent="buttonClick('LINKS')"
                                   class="btn btn-lg ml-btn ml-bk-corp ml-white" v-tooltip:right="'View your recruiting Links'"
                                   :disabled="hasNoAppointments">
                              <i class="fi-ecommerce-settings"></i>
                              View Appointment Links
                           </button>
                        </div>
                        <div class="text-center">
                           <button type="button" @click.prevent="buttonClick('HELP')"
                                   class="btn btn-lg ml-btn ml-bk-corp ml-white" v-tooltip:right="'Get help with ' + appName">
                              <i class="fi-interface-telephone"></i>
                              Help
                           </button>
                        </div>

                     </div>
                  </div>
               </div>
            </div>
            <div class="col-sm-3">
               <div v-if="approved.length > 0" class="b-card agent-numbers">
                  <div class="card-header bg-transparent">Your Agent Numbers:</div>
                  <div class="card-body">
                     <div class="padl-12" v-for="(a, indx) in approved" :key="indx">
                        <i class="fas fa-user-check"></i>
                        {{ a }}
                     </div>
                  </div>
               </div>
            </div>
         </div>
      </div>
   </div>
</template>

<script>
   import { mapGetters } from 'vuex';
   import Const from "@/services/Constants";

   export default {
      data() {
         return {
            loading: false,
            c: new Const(),
            appName: process.env.VUE_APP_TITLE,
            AppProgress: "Start",
            appointments: [],
            approved: [],
            pending: [],
            now: new Date(),
            deleteAfterXDays: parseInt(process.env.VUE_APP_ABANDON_DAYS),
            warningDays: 0,
            showTips: true,
            hierarchies: [],
         };
      },
      async created() {
         await this.initialize();
         if (localStorage[this.c.STOR_UPD_PROFILE] == "TRUE") {
            await this.updateProfile();
         }
         await this.updateApptCollections()
      },
      computed: {
         ...mapGetters(["isVBAppointment"]),
         hasNoAppointments: function() {
            if (this.$store.getters.appUser.userRoleCode == "USRROLE_MD")
               return false;

            let k = 0;
            this.appointments.forEach((itm, index) => {
               if (itm.status == "APWF_STATUS_APPROVED") {
                  k++;
               }
            });
            return k == 0;
         },
         displayAppointments() {
            return this.appointments
               .filter(a => a.status !== 'APWF_STATUS_APPROVED' || this.isVBAppointment);
         }
      },
      methods: {
         async initialize() {
            this.loading = true;
            await this.getAppointments();
            this.$store.commit("updateAppointments", this.appointments);

            let newLink = this.$store.getters.appointmentLink;

            if (newLink.length > 2 && newLink.substr(0, 3) == 'USR' ||
               newLink.length > 2 && newLink.substr(0, 3) == 'EXT' ||
               newLink.length > 1 && newLink.substr(0, 2) == 'MD') {
               newLink = ''
            }

            //add pending invites to the appointments colleciton
            this.addPendingToAppointments()

            // in case a NON-MD was invited externally
            let usr = this.$store.getters.appUser;
            let isApproved = false
            if (usr && usr.userRoleCode && usr.userRoleCode != "USRROLE_MD") {
               if (newLink && newLink.length) {
                  let found = false;
                  // Check if the new link is already attributed to user
                  this.appointments.forEach((itm) => {
                     if (
                        (itm.link) &&
                        itm.link != null &&
                        itm.link.toUpperCase() == newLink.toUpperCase()
                     ) {
                        found = true;
                     }
                  });
                  if (!found) {

                     if (newLink.length > 2 && newLink.substr(0, 3) == "MLT") { // MULTI-appointment Link
                        await this.$appoint.getMultiLink(newLink.substr(3))
                           .then(r => {
                              if (r) {
                                 let present = false
                                 // Check if the new link was already used to create appointment
                                 this.appointments.forEach((itm) => {

                                    let linkExists = r.multiLinkIds.filter(id => id == itm.multiLinkId).length > 0
                                    if (itm.link == null && (itm.multiLinkId) && linkExists) {
                                       present = true;
                                    }
                                    /* 7-17-2023 bug 13636
                                       check if any of the appointmentLinks in r.multiLinks contains the appointmentLink tied
                                       to an approved appointment in itm. If so then the user is already configured for the link they
                                       signed in with
                                    */
                                    var exists = r.multiLinks.filter(link => link == itm.link).length > 0
                                    if (exists && itm.status == 'APWF_STATUS_APPROVED') {
                                       present = true
                                       isApproved = true
                                    }
                                 });
                                 if (!present) {
                                    this.appointments.push({
                                       link: newLink, status: "NEW",
                                       multiLinkId: r.multiLinkId,
                                       multiLinks: r.multiLinks,
                                       linkCarrierLevelProductTypeList: r.linkCarrierLevelProductTypeList,
                                       apptType: r.apptType,
                                    });
                                 }
                                 else if (isApproved) {
                                    this.$swal(
                                       "Already Configured",
                                       "The link you given us represents a schedule that you are already configured for.  If necessary, please contact your upline for a valid link.",
                                       "warning"
                                    )
                                    return
                                 }
                              }
                           })

                     } else { // Normal Appointment Link
                        //Before putting to the new link to the dashboard.  Lets validate the link and make sure there is no agent assigning to the same hierarchy twice.
                        let payload = {
                           link: newLink,
                           emailAddress: this.$store.getters.appUser.userName,
                           apptTypeCode: null
                        }

                        await this.$appoint.validateAppointmentAndLink(payload)
                           .then(r => {
                              if (r == null) {
                                 this.$swal(
                                    "System Error",
                                    "Oops!  Some unforseen system error occurred while trying to validating appointment information.  Please try again later. If this problem persists, please contact support.",
                                    "error"
                                 )
                                 return
                              } else {
                                 if (r.result == true && r.failureReasonCode == null) {
                                    this.appointments.push({ link: newLink, status: 'NEW' })
                                 } else {
                                    if (r.result == false && r.failureReasonCode != null) {
                                       let msg = ""
                                       let title = ""
                                       switch (r.failureReasonCode) {
                                          case 'BAD_APPT_LINK':
                                             title = "Bad Appointment Link"
                                             msg = "The appointment link is bad.  If necessary, please contact your upline for a good link."
                                             break
                                          case 'AGENT_CANNOT_BE_IN_SAME_SCHEDULE_TWICE':
                                             title = "Already Configured"
                                             msg = "The link you given us represents a schedule that you are already configured for.  If necessary, please contact your upline for a valid link."
                                             break
                                          default:
                                             msg = "Some unforseen system error.  It should never happen."
                                             break
                                       }
                                       this.$swal(
                                          title,
                                          msg,
                                          "warning"
                                       )
                                       return
                                    }
                                 }
                              }
                           })
                           .catch((err) => {
                              this.$swal(
                                 "System Error",
                                 "Oops!  Some Some unforseen system error occurred while trying to validating appointment information. Please try again later. If this problem persists please contact support.",
                                 "error"
                              )
                              return
                           })

                     }
                  }
               }
            }

            // Display warning if needed
            this.warningDays = 0;
            this.appointments.forEach((itm, index) => {
               if (itm.status == "APWF_STATUS_INCOMPLETE") {
                  let tdif = this.now.getTime() - new Date(itm.startDt).getTime();
                  let daze =
                     this.deleteAfterXDays - Math.floor(tdif / (1000 * 3600 * 24));
                  if (this.warningDays == 0 && daze > 0) this.warningDays = daze;
               }
            });

            // Make sure they have SOME appointments (if not an MD)
            var userRole = this.$store.getters.appUser.userRoleCode;
            if (userRole != "USRROLE_MD") {
               if (this.appointments.length == 0) {
                  this.$swal(
                     "No Apps or Invitations Found",
                     "We have not found your invitation. Please click the invitation link found in your email to log back in.",
                     "error"
                  ).then(() => {
                     this.$auth.logout();
                     this.loading = false;
                     return;
                  });
               } else if (this.appointments.length == 0) {
                  this.$swal(
                     "No Applications Found",
                     "Begin the appointment process by clicking the 'Start Your Appointment' button.",
                     "warning"
                  );
               }
            }

            // Store appt count so we can hide menus etc...
            this.$store.commit("updateHasAppointments", !this.hasNoAppointments);
            this.$store.commit("updateAuthInProgress", false);

            await this.$nextTick();
            this.loading = false;
         },
         async getAppointments() {
            this.appointments = [];
            this.appointments = await this.$appoint.getAppointments(
               this.$store.getters.appUser.userId
            );
            this.pending = await this.$appoint.getPendingInvites(
               this.$store.getters.appUser.userId
            );

            if (!this.appointments) this.appointments = [];
            if (!this.pending) this.pending = [];
         },
         async updateProfile() {
            if (this.$auth.isAuthenticated()) {
               localStorage[this.c.STOR_UPD_PROFILE] = "";
               await this.$auth.updateLocalProfile();
            }
         },
         async buttonAppoint(appt) {
            await this.$nextTick(); // Give us a moment for the tooltips to UNrender themselves

            if (appt) {
               if (appt.status == "NEW") {
                  this.$router.push({ name: "wizard", params: { link: appt.link, multiLinkId: appt.multiLinkId, multiLinks: appt.multiLinks } });
               } else {
                  this.$router.push({
                     name: "appoint",
                     params: { id: appt.appointmentId },
                  });
               }
               return;
            }

            //find first incomplete appointment
            this.appointments.forEach((itm, index) => {
               if (
                  itm.status != "APWF_STATUS_APPROVED" &&
                  itm.status != "NEW" &&
                  itm.status != "APWF_STATUS_NEWCONTRACT"
               ) {
                  this.$router.push({
                     name: "appoint",
                     params: { id: itm.appointmentId },
                  });
                  return;
               }
            });
         },
         buttonClick(btn) {
            let parms = {
               useLocalStorage: false
            }
            switch (btn) {
               case "AGENTS":
                  this.$router.push({ name: "agents" });
                  break;
               case "LINKS":
                  this.$router.push({ name: "linx", params: parms });
                  break;
               case "HELP":
                  this.$router.push({ name: "help" });
                  break;
            }
         },
         async updateApptCollections() {
            await this.$store.dispatch("getHierarchies")
            this.hierarchies = this.$store.getters.hierarchies
            if (this.hierarchies) {
               this.hierarchies.forEach((itm, index) => {
                  if (!this.approved.includes(itm.agentNo)) {
                     this.approved.push(itm.agentNo)
                  }
               })
            }
         },
         getToolTipText(lclptList) {
            var toolTipText = ""
            if (lclptList) {
               lclptList.forEach((item, cnt) => {
                  var text = "Level " + item.level + " " + item.productType
                  toolTipText += text;
                  if (cnt < lclptList.length - 1) {
                     toolTipText += ", "
                  }
               })
            }
            return toolTipText;
         },
         addPendingToAppointments() {
            //don't add pending invitations to the appointments list
            //if the appointment list has an appointment with the same
            //multiLinkId or appointmentLinkId
            this.pending.forEach((itm) => {
               let a = this.appointments
               let addItm = true
               if (itm.multiLinkId != null) {
                  //if exists in appointment do not add...set to false
                  addItm = !(this.appointments.filter(a => a.multiLinkId == itm.multiLinkId).length > 0)

                  //the pending invite can be multi-link invite but it needs
                  //be also checked against approved appointments which should compare the multi link in pending
                  //against the link in appointment
                  if (addItm) {
                     let found = false;
                     this.appointments.forEach((appt) => {
                        //invite appointmentLink found in existing appointment...do not add the invite to the appointments collection
                        if (!found) //break out of forEach once the appointment has been found
                        {
                           addItm = !(itm.multiLinks.filter(link => link == appt.link).length > 0)
                           if (!addItm) {
                              found = true
                           }
                        }
                     })
                  }
               }

               if (itm.appointmentLinkId != null) {
                  //if exists in appointment do not add...set to false
                  addItm = !(this.appointments.filter(a => a.appointmentLinkId == itm.appointmentLinkId).length > 0)
               }

               if (addItm) {
                  this.appointments.push({
                     link: itm.link,
                     status: "NEW",
                     multiLinkId: itm.multiLinkId,
                     multiLinks: itm.multiLinks,
                     linkCarrierLevelProductTypeList: itm.linkCarrierLevelProductTypeList,
                     apptType: itm.apptType,
                  });
               }
            });

         },
         forApplicationLevel(a) {
            if (this.isVBAppointment) { return ""; }
            return ` for: ${this.getToolTipText(a.linkCarrierLevelProductTypeList)}`
         },
      }
   };
</script>

<style lang="scss" scoped>
   @import "../assets/css/colors.scss";

   form {
      max-width: 600px;
   }

   .btnw {
      min-width: 100px;
   }

   .btnw:hover {
      color: $corp-orange;
   }

   .result-box {
      min-height: 400px;
   }

   .none-found {
      font-style: italic;
      font-size: smaller;
      color: $corp-ltblue;
   }

   option::first-letter {
      font-family: Glyphicons Halflings;
   }

   .dash-box {
      max-width: 500px;
      font-size: 1.4em;
      padding: 0 24px;
   }

   .dash-box button {
      width: 100%;
      font-size: 1.5rem;
   }

   .dash-box button:focus {
      width: 100%;
      outline-style: none !important;
      outline-color: transparent !important;
   }

   .agent-numbers {
      font-size: .75em;
   }

   #pgHome {
      min-height: 600px;
   }

   .wf-btn {
      padding: 0;
   }

   .wf-btn span {
      display: inline-block;
      width: 100%;
      padding: 8px;
   }
</style>

